/**
 *
 * @module Category
 */
(function Category() {
    /**
     * event category filter handling
     *
     * @class {categoryFilter}
     * @constructor
     */
    function categoryFilter() {
        /**
         * @type {categoryFilter}
         * @private
         */
        var _this = this;

        // selector for the filter
        var filterSelector = '[data-category="filter"]';
        // selector for an item
        var itemSelector = '[data-category="item"]';
        // selector for the item container
        var itemContainerSelector = '[data-category="item-container"]'
        // header selector
        var headerSelector = '[data-html-element="header"]'
        // the scroll position of the item container
        var itemContainerScrollPos;


        /**
         * filters the items based on a category
         *
         * @param {jQuery} $element a jQuery dom element
         */
        this.filterByElement = function ($element) {
            if (typeof $element !== 'object' && $element.length !== 1) {
                return false;
            }
            $(filterSelector).removeClass('active');
            var filterValue = $element.data('category-filter');
            // add active class to the current filter
            $element.addClass('active');
            // each over all events
            $(itemSelector).each(function (idx, item) {
                // split the category values and put it into an array
                $itemCategories = $($(item).data('categories').split(' '));
                if ($.inArray(filterValue, $itemCategories) !== -1) {
                    $(this).show(500);
                } else {
                    $(this).hide(300);
                }
            });

            //scroll to the events container
            _this.scrollToEvents();
        };

        /**
         * Calculate the position of the event items with respect to the header height
         *
         * @method calculateItemContainerScrollPosition
         * @returns {undefined}
         */
        this.calculateItemContainerScrollPosition = function () {
            var headerHeight = $(headerSelector)[0].offsetHeight;
            var itemContainerOffsetTop = $(itemContainerSelector).offset().top;

            itemContainerScrollPos = itemContainerOffsetTop - headerHeight;
        }

        /**
         * Scroll to the first event after a filter has been applied
         * @method scrollToEvents
         * @returns {undefined}
         */
        this.scrollToEvents = function () {
            $('html, body').animate({
                scrollTop: itemContainerScrollPos
            }, 'slow')
        }

        /**
         * visibility and behavior category filter
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            if ($(filterSelector).length) {
                _this.calculateItemContainerScrollPosition();
                $(filterSelector).click(function () {
                    _this.filterByElement($(this));
                });
                if (window.location.hash) {
                    _this.filterByElement($("[href='" + window.location.hash + "']" + filterSelector));
                }
            }
        };
        _this.init();
    }


    if (typeof document.addEventListener === 'function') {
        document.addEventListener('TechDivision.Event.initialize', function (event) {
            var filter = new categoryFilter();
        }, false);
    }
})();